import React from 'react';

const ExperienceDetails = ({
    duration, designation, company, onContract, isPermanent, summary
}) => {
    return (
        <div className="row m-0">
            <div className="work-duration">
                <span className="sub-heading">{duration}</span>
            </div>
            <div className="col">
                <span className="sub-heading designation">{designation} </span>
                <span className="sub-heading d-block company-name grey-text text-darken-1">{company}</span>
                <p className="work-summary">
                    <span dangerouslySetInnerHTML={{__html: summary}}></span>
                </p>
            </div>
        </div>
    );
};

export default ExperienceDetails;
